// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3OlqI","title":"FrontImage_title__24Wfa"};